module.exports = __webpack_public_path__ + "img/liangfantuan_header.a383bea9.png";